import React from "react";
import { useTranslation } from "react-i18next";
import ModalLayout from "app/components/Layouts/ModalLayout/ModalLayout";
import styles from "./styles.module.scss";

type Props = {
  isOpen: boolean;
  subscriptionName: string;
  onClose: () => void;
  onViewPurchases: () => void;
};

const PurchaseSuccessModal: React.FC<Props> = ({
  isOpen,
  subscriptionName,
  onClose,
  onViewPurchases,
}) => {
  const { t } = useTranslation();

  if (!isOpen) { return null; }

  return (
    <ModalLayout isOpen={isOpen} classNames={`${styles.modal}`}>
      <div className={`${styles.modal_header} ${styles.w_100}`}>
        <i className={`ico ico-check ${styles.modal_status_icon} ${styles.success}`} />
        <h2>
          {t("You’ve successfully purchased {{subscription}}", {
            subscription: subscriptionName,
          })}
        </h2>
      </div>

      <div className={`${styles.modal_content}`}>
        {t(
          "You can see all your purchases in Payments and Subscriptions in Settings"
        )}
      </div>

      <div className={styles.confirm_conflict_actions}>
        <button
          onClick={onClose}
          className={`${styles.confirm_button} btn btn-primary`}
        >
          {t("Got it")}
        </button>
        <button
          onClick={onViewPurchases}
          className={`${styles.cancel_button} btn btn-secondary-outline`}
        >
          {t("View My Purchases")}
        </button>
      </div>
    </ModalLayout>
  );
};

export default PurchaseSuccessModal;
